import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import moment from 'moment';
import { useMemo } from 'react';
import FormsPopup from '../../common/FormsPopup/FormsPopup';
import UserAvatar from '../../common/UserAvatar/UserAvatar';
import { MemberDetailsProps } from './types';
import styles from './style';
import { getUserStatus } from '../../../containers/PartnerAndMembers';

const getGender = (gender: number) => {
    switch (gender) {
        case 1:
            return 'Man';
        case 2:
            return 'Woman';
        case 3:
            return 'Transgender';
        case 4:
            return 'Non-binary/non-conforming';
        case 5:
            return 'Prefer not to respond';

        default:
            return '';
    }
};

const MemberDetails = ({
    openMemberDetails,
    setOpenMemberDetails,
    setEditMemberDetails,
    memberData,
    setChangeStatus,
    handleAddMemberPrimaryAddress,
    handleUpdateAdditionalAddress,
}: MemberDetailsProps) => {
    const primaryAddress = useMemo(() => {
        return memberData?.patientAddress?.find((a) => a.isDefault);
    }, [memberData]);

    return (
        <FormsPopup
            id="member_details"
            open={openMemberDetails}
            title="Member Details"
            textAlign="left"
            handleClose={() => setOpenMemberDetails(false)}
            width={662}
        >
            <Box component="form" noValidate>
                <Typography component="div" sx={{ mb: 3 }}>
                    <UserAvatar
                        name={`${memberData?.firstname} ${memberData?.lastname}`}
                        source={
                            memberData?.signedImageUrl &&
                            memberData?.signedImageUrl !== 'null' &&
                            memberData?.signedImageUrl !== 'undefined'
                                ? memberData?.signedImageUrl
                                : ''
                        }
                        size={80}
                        radius="8px"
                        fontSize={20}
                    />
                </Typography>
                <Box>
                    <Typography sx={styles.profileLable}>Status:</Typography>
                    <Box sx={styles.statusContainer}>
                        <IconButton data-testid="userStatus" onClick={() => setChangeStatus(true)} sx={{ padding: 0 }}>
                            <img
                                alt="status"
                                src={
                                    memberData?.userStatusId === '1' || memberData?.userStatusId === '2'
                                        ? '/images/active-toggle.png'
                                        : '/images/disable-toggle.png'
                                }
                            />
                        </IconButton>
                        <Typography sx={styles.statusText}>
                            {getUserStatus(String(memberData?.userStatusId))}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={styles.gridContainer}>
                    <Box>
                        <Typography sx={styles.profileLable}>First Name</Typography>
                        <Typography sx={styles.profileValue}>{memberData?.firstname}</Typography>
                    </Box>
                    <Box>
                        <Typography sx={styles.profileLable}>Last Name</Typography>
                        <Typography sx={styles.profileValue}>{memberData?.lastname}</Typography>
                    </Box>
                    <Box>
                        <Typography sx={styles.profileLable}>Email</Typography>
                        <Typography sx={styles.profileValue}>{memberData?.email}</Typography>
                    </Box>
                    <Box>
                        <Typography sx={styles.profileLable}>Phone Number</Typography>
                        <Typography sx={styles.profileValue}>{memberData?.phone}</Typography>
                    </Box>
                    <Box>
                        <Typography sx={styles.profileLable}>Diabetes Type</Typography>
                        <Typography sx={styles.profileValue}>
                            {memberData?.patientCondition
                                .filter((it) => !['5'].includes(it.condition.id))
                                .map((it) => it.condition.subtype)
                                .join(',')}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography sx={styles.profileLable}>Gender</Typography>
                        <Typography sx={styles.profileValue}>{getGender(Number(memberData?.gender || 0))}</Typography>
                    </Box>
                    <Box>
                        <Typography sx={styles.profileLable}>Subscriber ID</Typography>
                        <Typography sx={styles.profileValue}>{memberData?.subscriberId}</Typography>
                    </Box>
                    <Box>
                        <Typography sx={styles.profileLable}>Date of Birth</Typography>
                        <Typography sx={styles.profileValue}>
                            {memberData?.dateOfBirth ? moment(memberData.dateOfBirth).format('MM/DD/YYYY') : ''}
                        </Typography>
                    </Box>
                    {primaryAddress ? (
                        <Box>
                            <Typography sx={styles.profileLable}>Primary Address</Typography>
                            <Typography sx={styles.profileValue}>{`${primaryAddress.address1}, ${
                                primaryAddress.address2 ? `${primaryAddress.address2}, ` : ''
                            }${primaryAddress.city}, ${primaryAddress.state}, ${primaryAddress.zip}`}</Typography>
                        </Box>
                    ) : null}
                    <Box>
                        <Typography sx={styles.profileLable}>Partner</Typography>
                        <Typography sx={styles.profileValue}>{memberData?.employer?.name}</Typography>
                    </Box>
                </Box>
                {!memberData?.patientAddress?.length ? (
                    <IconButton
                        data-testid="addAddressAction"
                        sx={styles.addAddressContainer}
                        onClick={handleAddMemberPrimaryAddress}
                    >
                        <Typography sx={styles.addAddressText}>Add Primary Address</Typography>
                        <img alt="add" src="/images/add.svg" />
                    </IconButton>
                ) : (
                    memberData?.patientAddress?.length > 1 && (
                        <IconButton
                            data-testid="editAddressAction"
                            sx={styles.addAddressContainer}
                            onClick={handleUpdateAdditionalAddress}
                        >
                            <Typography sx={styles.addAddressText}>Additional Addresses</Typography>
                            <img alt="edit" src="/images/edit.png" />
                        </IconButton>
                    )
                )}
                <Grid container justifyContent="center">
                    <Button
                        variant="contained"
                        sx={styles.profileButton}
                        onClick={() => {
                            setEditMemberDetails(true);
                        }}
                        id="editMemberDetails"
                        data-testid="editMemberDetails"
                    >
                        Edit Member
                    </Button>
                </Grid>
            </Box>
        </FormsPopup>
    );
};
export default MemberDetails;
